<template>
  <form-container size="small">
    <h3>Logout</h3>

    <loading-indicator v-if="isLoading"/>

    <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
  </form-container>
</template>

<script>
/**
* Logs out the currently logged in user.
*/
export default {
  name: 'LogoutScreen',
  data () {
    return {
      isLoading: false,
      errorMsg: null
    }
  },
  mounted () {
    this.logout()
  },
  methods: {
    async logout () {
      this.isLoading = true

      try {
        await this.$store.dispatch('logout')
        this.$router.push({name: 'login'})
      } catch (error) {
        this.errorMsg = error.message
      }
      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LogoutScreen.vue